import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Small timeout to allow Lenis/Router to finish their internal state updates
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      // If lenis is globally available, explicitly tell it to scroll to top
      if (window.lenis) {
        window.lenis.scrollTo(0, { immediate: true });
      }
    }, 100);
  }, [pathname]);

  return null;
}
